import PickupType from "../../enums/PickupType";
import Game from "../Game";
import GameCore from "../GameCore";
import BasePickup from "./BasePickup";
import PickupGroup from "./PickupGroup";
import hapticFeedback from "../../../utils/haptics";
import PICKUPS from "../../consts/PICKUPS";
import {
  SPRITESHEET_KEYS,
  SPRITESHEET_FRAMES,
} from "../../consts/SPRITESHEETS";

export default class CoinPickup extends BasePickup {
  landingLocation: Phaser.Math.Vector2;
  coinId?: string;
  isFromGift: boolean = false;
  isFromCaravan: boolean = false;

  constructor(
    group: PickupGroup,
    x: number,
    y: number,
    pickupType = PickupType.COIN
  ) {
    super(group, x, y, pickupType, SPRITESHEET_KEYS.PICKUPS);
    this.setTexture(SPRITESHEET_KEYS.PICKUPS, SPRITESHEET_FRAMES.PICKUPS.COIN);
    this.landingLocation = new Phaser.Math.Vector2(0, 0);
    this.time = 0;

    // Prevent coins from being culled when off-screen
    this.isCullable = false;

    Game.Core.scene.add.existing(this);
    this.setScale(1.5 * GameCore.PixelScale);
  }

  OnRecycle(): void {
    super.OnRecycle();
    this.setTexture(SPRITESHEET_KEYS.PICKUPS, SPRITESHEET_FRAMES.PICKUPS.COIN);

    // Reset flags and value to defaults to avoid leaking special values across pooled instances
    this.isFromCaravan = false;
    this.isFromGift = false;
    this.value = PICKUPS[PickupType.COIN].value;
  }

  Update(): void {
    super.Update();
    this.setDepth(this.y - Game.Core.Player.y);
  }

  GetTaken(): void {
    // Play coin pickup sound using pooled audio (sound settings handled by facade)
    Game.Core.poolManager?.playCoinSound();

    if (hapticFeedback.impactOccurred.isAvailable()) {
      hapticFeedback.impactOccurred("soft");
    }

    // Show coin counter animation
    Game.Core.coinCounters.Spawn(this.x, this.y);

    // Add coins to player's total
    Game.Core.PlayerOptions.AddCoins(this.value);
    Game.Core.MainUI.UpdateCoins();

    // Handle different coin sources appropriately
    if (this.isFromCaravan) {
      // Caravan coins are counted for the caravan claim
      Game.Core.caravanCoinsCollected += this.value;
    } else {
      // All other coins are considered from gifts
      Game.Core.giftCoinsCollected += this.value;
    }

    this.isFromCaravan = false;
    this.isFromGift = false;

    super.GetTaken();
  }
}
